import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import QuestsContent from "modules/Quests/QuestsContent";

import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const QuestsPage: React.FC = () => {
  setTitle("Quest Management");
  return (
    <Auth>
      <Layout>
        <QuestsContent />
      </Layout>
    </Auth>
  );
};

export default QuestsPage;
